var O = Object.defineProperty, Y = Object.defineProperties;
var q = Object.getOwnPropertyDescriptors;
var h = Object.getOwnPropertySymbols;
var J = Object.prototype.hasOwnProperty, Q = Object.prototype.propertyIsEnumerable;
var x = (l, s, a) => s in l ? O(l, s, { enumerable: !0, configurable: !0, writable: !0, value: a }) : l[s] = a, B = (l, s) => {
  for (var a in s || (s = {}))
    J.call(s, a) && x(l, a, s[a]);
  if (h)
    for (var a of h(s))
      Q.call(s, a) && x(l, a, s[a]);
  return l;
}, H = (l, s) => Y(l, q(s));
var w = (l, s, a) => new Promise((y, m) => {
  var f = (i) => {
    try {
      u(a.next(i));
    } catch (o) {
      m(o);
    }
  }, p = (i) => {
    try {
      u(a.throw(i));
    } catch (o) {
      m(o);
    }
  }, u = (i) => i.done ? y(i.value) : Promise.resolve(i.value).then(f, p);
  u((a = a.apply(l, s)).next());
});
import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { postGetOrgPageList as W } from "../../request/designordercenter/productionOrder/specialApply/getOrgPageList/post.js";
import { defineComponent as X, useTemplateRef as Z, onMounted as $, openBlock as A, createElementBlock as K, createElementVNode as k, createVNode as N, withCtx as b, createTextVNode as T, createBlock as j, createCommentVNode as I, Fragment as ee } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useMessage as te } from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/use-message.js";
import ae from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/data-table/src/DataTable.js";
import se from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/pagination/src/Pagination.js";
import z from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/button/src/Button.js";
import le from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/spin/src/Spin.js";
import { ref as d, unref as g } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const ne = { style: { width: "100%", display: "flex", "justify-content": "end" } }, oe = { style: { width: "100%", display: "flex", "justify-content": "center" } }, ve = /* @__PURE__ */ X({
  __name: "indexTableItem",
  props: {
    businessId: { default: "" },
    isShowAddApprovalButton: { type: Boolean, default: !1 },
    isAll: { type: Boolean, default: !1 },
    status: { default: "" }
  },
  emits: ["submit", "cancal", "addApproval"],
  setup(l, { expose: s, emit: a }) {
    const y = l, m = Z("relatedApprovalContainer"), f = te(), p = d([]), u = d(!0), i = d(0), o = d([]), v = d(!1), D = [
      {
        type: "selection",
        multiple: !u.value,
        disabled(e) {
          return e.status !== "pass";
        }
      },
      {
        title: "流程编号",
        key: "no",
        align: "center"
      },
      {
        title: "申请类型",
        key: "applyTypeName",
        align: "center"
      },
      {
        title: "流程处理状态",
        key: "statusName",
        align: "center"
      },
      {
        title: "发起对象类型",
        key: "businessTypeName",
        align: "center"
      },
      {
        title: "发起对象编码",
        key: "businessNo",
        align: "center"
      },
      {
        title: "审批品类",
        key: "vfdpApprovalCategoryName",
        align: "center"
      },
      {
        title: "审批类别",
        key: "vfdpApprovalCategoryType",
        align: "center"
      },
      {
        title: "客户姓名",
        key: "businessName",
        align: "center"
      },
      {
        title: "申请人",
        key: "applyer",
        align: "center"
      },
      {
        title: "申请时间",
        key: "applyDt",
        align: "center"
      }
    ], L = (e) => {
      u.value && e.length > 1 ? p.value = [e[e.length - 1]] : p.value = e;
    }, r = d({
      pageSize: 10,
      pageNum: 1,
      applyTypeList: ["bpm_process_djjspecial_judge"],
      businessType: "business_serviceNo",
      status: "",
      businessId: "",
      isCreatorId: void 0,
      statusList: void 0
    });
    $(() => w(this, null, function* () {
      M();
    }));
    function R(e, t = "yyyy-MM-dd HH:mm:ss") {
      const n = typeof e == "string" || typeof e == "number" ? new Date(e) : e;
      if (isNaN(n.getTime()))
        return "";
      const c = (S) => S.toString().padStart(2, "0"), G = {
        yyyy: n.getFullYear().toString(),
        MM: c(n.getMonth() + 1),
        dd: c(n.getDate()),
        HH: c(n.getHours()),
        mm: c(n.getMinutes()),
        ss: c(n.getSeconds())
      };
      return t.replace(/yyyy|MM|dd|HH|mm|ss/g, (S) => G[S] || "");
    }
    const _ = () => w(this, null, function* () {
      try {
        v.value = !0;
        const e = yield W(r.value);
        e && e.data && e.status ? (v.value = !1, o.value = e.data.records || [], i.value = e.data.total || 0, o.value = o.value.map((t) => H(B({}, t), {
          applyDt: t.applyDt ? R(t.applyDt, "yyyy-MM-dd HH:mm:ss") : ""
        }))) : (console.warn("获取数据失败：response 或 data 为空"), f.error((e == null ? void 0 : e.message) || "获取数据失败"), o.value = [], i.value = 0);
      } catch (e) {
        v.value = !1, console.error("请求失败:", e), o.value = [], i.value = 0;
      }
    }), V = (e) => {
      r.value.pageNum = e, _();
    }, P = (e) => {
      r.value.pageSize = e, _();
    }, U = () => {
      if (p.value.length === 0) {
        f.warning("至少选择一条数据");
        return;
      }
      const e = o.value.filter(
        (t) => p.value.includes(t.id)
      );
      C("submit", e);
    }, C = a, E = () => {
      C("cancal");
    }, F = () => {
      C("addApproval");
    }, M = () => {
      if (r.value = {
        pageSize: 10,
        pageNum: 1,
        applyTypeList: ["bpm_process_djjspecial_judge"],
        businessType: "business_serviceNo",
        status: "",
        businessId: y.businessId,
        isCreatorId: void 0
      }, y.isAll ? r.value.status = "" : r.value.statusList = ["pass", "auditing", "draft"], !r.value.businessId)
        return !1;
      _();
    };
    return s({ init: M }), (e, t) => (A(), K(ee, null, [
      k("div", {
        ref_key: "relatedApprovalContainer",
        ref: m
      }, null, 512),
      N(g(le), { show: v.value }, {
        default: b(() => [
          t[5] || (t[5] = k("div", { style: { "margin-bottom": "5px", color: "red" } }, "只有单据状态为审核通过后，订单才可传单", -1)),
          N(g(ae), {
            columns: D,
            data: o.value,
            bordered: !1,
            "onUpdate:checkedRowKeys": L,
            "row-key": (n) => n.id
          }, null, 8, ["data", "row-key"]),
          k("div", ne, [
            N(g(se), {
              page: r.value.pageNum,
              "onUpdate:page": t[0] || (t[0] = (n) => r.value.pageNum = n),
              "page-size": r.value.pageSize,
              "onUpdate:pageSize": t[1] || (t[1] = (n) => r.value.pageSize = n),
              "show-size-picker": "",
              "on-update:page": V,
              "on-update:page-size": P,
              "page-sizes": [10, 20, 30, 40]
            }, null, 8, ["page", "page-size"])
          ]),
          k("div", oe, [
            N(g(z), { onClick: E }, {
              default: b(() => t[2] || (t[2] = [
                T("取消", -1)
              ])),
              _: 1,
              __: [2]
            }),
            o.value.length && (e.status == -1 || e.status == 0) ? (A(), j(g(z), {
              key: 0,
              onClick: U,
              style: { "margin-left": "30px" },
              type: "primary"
            }, {
              default: b(() => t[3] || (t[3] = [
                T("确定", -1)
              ])),
              _: 1,
              __: [3]
            })) : I("", !0),
            y.isShowAddApprovalButton ? (A(), j(g(z), {
              key: 1,
              onClick: F,
              style: { "margin-left": "30px" },
              type: "primary"
            }, {
              default: b(() => t[4] || (t[4] = [
                T("新增审批", -1)
              ])),
              _: 1,
              __: [4]
            })) : I("", !0)
          ])
        ]),
        _: 1,
        __: [5]
      }, 8, ["show"])
    ], 64));
  }
});
export {
  ve as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/approval-table/indexTableItem.vue.js
// module id = 826
// module chunks = 41